module.exports = __webpack_public_path__ + "assets/a0130eaebccf1cfecb7b22572dbc9614.png";